import React, { useEffect, useState } from 'react';

import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import SectionMessage from '@atlaskit/section-message';
import { redirectToRuleChangeValidation } from 'src/services/webhooksValidator';

import integration from 'src/lib/api/integration';
import jira from 'src/lib/api/jira';
import { getQueryParams } from 'src/lib/history';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';
import ModalContainer from 'src/views/components/ModalContainer';

const RemoveRuleModal = () => {
  const [removing, setRemoving] = useState(false);
  const [removingError, setRemovingError] = useState(undefined);
  const [{ loading, rule, error }, setRule] = useState({ loading: true, rule: undefined, error: undefined });

  const { id } = getQueryParams();

  useEffect(() => {
    integration.getRule(id)
      .then(rule => setRule({ loading: false, rule }))
      .catch(error => setRule({ loading: false, error }));
  }, [id]);

  const remove = () => {
    setRemoving(true);
    Promise.all([integration.removeRule(id), integration.getAccountMapping()])
      .then(([, { metadata }]) => {
        if (metadata.disable_automatic_webhooks_update) {
          jira.closeCurrentModal();
        } else {
          redirectToRuleChangeValidation(rule, undefined);
        }
      })
      .catch(e => setRemovingError(e))
      .then(() => setRemoving(false));
  };

  const View = () => {
    if (loading) return <CenteredSpinner size="large"/>;
    if (error) return <ErrorMessage error={['Can not find rule', error]}/>;
    return (
      <div>
        <SectionMessage appearance="warning" title="Rule and related data will be removed">
          We will remove:
          <ul>
            <li>The rule <em style={{ fontWeight: 'bold' }}>{rule.name}</em></li>
            <li>Webhooks (Both Jira and PagerDuty) used by only this rule</li>
          </ul>
          We leave:
          <ul>
            <li>Webhooks used by other rules</li>
          </ul>
        </SectionMessage>
        <br/>
        {removingError && <ErrorMessage error={['Failed to remove rule', removingError]}/>}
        <br/>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonGroup>
            <Button onClick={e => jira.closeCurrentModal()}>Cancel</Button>
            <LoadingButton appearance="danger" onClick={remove} isLoading={removing}>Remove Rule</LoadingButton>
          </ButtonGroup>
        </div>
        <br/>
        <br/>
      </div>
    );
  };

  return (
    <ModalContainer title="Confirm Rule removal">
      <View/>
    </ModalContainer>
  );
};

export default RemoveRuleModal;
